<template>
    <div class="lms__superadmin_workspaces_list">
        <div class="lms__superadmin_workspaces_list_header">
            <component-induction-message
                :title="'Workspaces'"
                :content="'A Form workspace is a shared hub where specific content can be delivered, or specific users can be grouped. Users can join more than one workspace and switch between them in seconds.'"
                :link-to="''"
                :theme="'primary'"
                :route-name="'lms-superadmin-workspace-list'"
            ></component-induction-message>
            <view-actions
                :title="$t('lms.workspace.title.workspaces')"
                :cancel-button-active="false"
                :submit-button-text="$t('lms.workspace.search.addWorkspace')"
                :submit-button-active="user.isSuperadmin() || user.isMasterAdministrator()"
                @emit-submit="createWorkspace"
            />
        </div>
        <div class="lms__superadmin_workspaces_list_main">
            <component-list
                :component-table="LmsSuperadminWorkspaceListTable"
                :component-table-name="'workspaces'"
                :filter-search-queryable="true"
                :filter-select-active="false"
                :filter-select-items="filtersSelect"
                :get-pagination-getter="'getLmsSuperadminWorkspacesPagination'"
                :get-items-getter="'getLmsSuperadminWorkspaces'"
                :get-items-dispatch="'lmsSuperadminWorkspacesGet'"
                :get-items-dispatch-trigger-name="'trigger-get-admins'"
                :item-name="['workspace', 'workspaces']"
                :table-preferences-active="true"
            />
        </div>
    </div>
</template>

<script>
import LmsSuperadminWorkspaceListTable from '@/components/lms/superadmin/workspace/list/LmsSuperadminWorkspaceListTable'
import ViewActions from '@/components/default/shared/ViewActions'
import ComponentList from '@/components/default/shared/ComponentList'
import ComponentInductionMessage from '@/components/default/shared/ComponentInductionMessage'
import { User } from '@/User'

export default {
  name: 'lms-superadmin-workspace-list',
  components: { ComponentInductionMessage, ComponentList, ViewActions },
  data () {
    return {
      LmsSuperadminWorkspaceListTable,
      user: new User()
    }
  },
  computed: {
    filtersSelect () {
      return [
        {
          key: 'status',
          label: 'Status',
          type: 'checkbox',
          values: [
            {
              label: 'Draft',
              value: 'draft'
            },
            {
              label: 'Active',
              value: 'active'
            }
          ]
        }
      ]
    }
  },
  methods: {
    createWorkspace () {
      this.$router.push({ name: 'lms-superadmin-workspace-add' })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/workspaces/_lmssuperadminworkspaceslist.scss";
</style>
